module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-nescafe-block-2-793308e33e6feb53398c4866299d274b.jpg";